export default "__VITE_ASSET__BdLeLnnF__"